export default __webpack_public_path__ + "static/media/europa_light.a42388e5.png";